const c = {
  name: "Globe",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 39.9" style="enable-background:new 0 0 32 39.9;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30.5,24.1c1-2.3,1.5-4.7,1.5-7.2c0-7.2-4.2-13.6-10.8-16.5L20.3,0l-1.6,3.7c-0.1,0-0.2,0-0.2-0.1
			c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.5-0.1-0.7-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.5-0.1-0.7-0.1c-0.2,0-0.4,0-0.6-0.1
			c-0.2,0-0.5,0-0.7,0c-0.2,0-0.4,0-0.6,0c-0.2,0-0.5,0-0.7,0c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.7,0.1c-0.2,0-0.4,0.1-0.6,0.1
			c-0.2,0-0.4,0.1-0.6,0.2s-0.4,0.1-0.6,0.2C9.7,3.6,9.5,3.7,9.3,3.8C9.1,3.8,8.9,3.9,8.7,4C8.5,4.1,8.3,4.2,8.1,4.3
			C7.9,4.3,7.7,4.4,7.5,4.5C7.3,4.6,7.1,4.8,6.9,4.9C6.7,5,6.5,5.1,6.3,5.2C6.2,5.3,6,5.5,5.8,5.6C5.6,5.7,5.5,5.8,5.3,6
			C5.1,6.1,4.9,6.3,4.8,6.4C4.6,6.6,4.4,6.7,4.3,6.8C4.1,7,3.9,7.2,3.8,7.4C3.6,7.5,3.5,7.7,3.4,7.8C3.2,8,3,8.2,2.9,8.4
			C2.8,8.6,2.6,8.7,2.5,8.9C2.4,9.1,2.2,9.4,2.1,9.6C2,9.8,1.9,9.9,1.8,10c-0.2,0.4-0.4,0.8-0.6,1.2l0,0.1c-0.2,0.4-0.4,0.9-0.5,1.3
			c-0.1,0.1-0.1,0.3-0.1,0.4c-0.1,0.3-0.2,0.6-0.2,0.9c0,0.2-0.1,0.4-0.1,0.6c0,0.3-0.1,0.5-0.1,0.8c0,0.2,0,0.4,0,0.6
			c0,0.2,0,0.5,0,0.7c0,0.2,0,0.4,0,0.6c0,0.2,0,0.5,0,0.7c0,0.2,0.1,0.4,0.1,0.7c0,0.2,0,0.4,0.1,0.6c0,0.2,0.1,0.5,0.1,0.7
			c0,0.2,0.1,0.4,0.1,0.6c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.1,0.4,0.2,0.5C1,22,1.1,22.3,1.2,22.5c0.1,0.2,0.1,0.3,0.2,0.5
			c0.1,0.2,0.2,0.5,0.4,0.7C1.8,23.8,1.9,24,2,24.1c0.1,0.2,0.3,0.5,0.5,0.7c0.1,0.1,0.2,0.2,0.3,0.4c0.2,0.2,0.4,0.5,0.5,0.7
			c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.2,0.4,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3
			c0.2,0.2,0.4,0.3,0.7,0.5c0.2,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.3,0.7,0.4c0.1,0,0.1,0.1,0.2,0.1l-1.2,2.8L5.9,33l0.9,0.4
			c2.3,1,4.7,1.5,7.2,1.5c0.3,0,0.7,0,1,0v3H4v2h24v-2H17v-3.3C22.9,33.7,28,29.7,30.5,24.1L30.5,24.1z M3.6,10.8
			c0.1-0.2,0.3-0.5,0.4-0.7c0.1-0.1,0.1-0.2,0.2-0.3c0.4-0.6,0.9-1.1,1.4-1.6c0.1-0.1,0.1-0.1,0.2-0.2C6,7.9,6.3,7.7,6.5,7.5
			c0.1,0,0.1-0.1,0.2-0.1C7.2,7,7.9,6.6,8.5,6.2c0,0,0.1,0,0.1,0c2-1,4.4-1.5,6.7-1.2c-2.3,1.7-4.7,5-6.4,8.6l-5.5-2.4
			c0,0,0-0.1,0-0.1C3.5,11,3.6,10.9,3.6,10.8L3.6,10.8z M9.4,28l-0.1-0.1c-1.4-0.7-1.8-5.4,0.7-11.7l7.3,3.2
			C14.4,25.5,10.8,28.5,9.4,28L9.4,28z M10.7,14.4c2.9-6.2,6.5-9.1,8-8.5c1.4,0.7,1.8,5.4-0.8,11.7L10.7,14.4L10.7,14.4z M2.6,13
			l5.5,2.4C6.7,19.1,5.8,23.1,6.2,26C2.5,22.9,1,17.7,2.6,13z M19.1,20.2l5.5,2.4c-2.4,4.4-7.1,6.8-11.9,6.2
			C15,27.2,17.4,23.8,19.1,20.2z M25.3,20.8l-5.5-2.4c1.5-3.7,2.3-7.7,1.9-10.6C25.4,10.9,26.9,16.1,25.3,20.8L25.3,20.8z M8.5,31.9
			l0.2-0.4l0.6-1.4c1.5,0.5,3.1,0.8,4.6,0.8c5.4,0,10.6-3.1,12.9-8.4l0-0.1c2.9-6.8,0-14.6-6.3-17.9l0.8-1.9
			c5.3,2.7,8.7,8.2,8.7,14.2c0,2.2-0.5,4.4-1.4,6.4c-2.3,5.2-7.1,8.8-12.8,9.5c-0.6,0.1-1.2,0.1-1.9,0.1
			C12.1,32.9,10.2,32.6,8.5,31.9L8.5,31.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Globe
};
